
import React,{Component,PropTypes} from 'react';
import {isNullOrEmpty} from "../actions/website-actions";
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as sActs from '../actions/server-actions';
import {Link} from 'react-router-dom';
class BreadCrumbs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      type: props.type
    }
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }




  render() {


    if(wActs.isNullOrUndefined(this.props.WebPage.Page)) { return null; }
    if(this.props.WebPage.UCMode) { return null; }

    let total = this.props.WebPage.Page.Breadcrumbs.length-1;


    return (
      <div className="breadcrumbs" style={{minHeight: "40px"}}>
        {this.state.type === "home" && this.props.WebPage.Page.Breadcrumbs.length>1 &&
          <ol vocab="http://schema.org/" typeof="BreadcrumbList">
            {this.props.WebPage.Page.Breadcrumbs.map((v,i) => {
              let reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
              //console.log(v.Url)
              let pathmatch = reg.exec( v.Url );
              let pathname = "/";
              if(pathmatch !== null && pathmatch.length>=2) { pathname=pathmatch[1]; }
              return (
                <React.Fragment  key={"bc-" + i}>
                  {i<total &&
                  <li property="itemListElement" typeof="ListItem">
                    <Link property="item" typeof="WebPage" to={pathname}>
                      <span property="name">{v.Title}</span>
                    </Link>
                    <meta property="position" content={i}/>
                  </li>
                  }
                </React.Fragment>
              );
            })}
          </ol>
        }
        {!wActs.isNullOrUndefined(this.props.WebPage.Page.Breadcrumbs[total]) &&
        <span className="bc-span">{this.props.WebPage.Page.Breadcrumbs[total].Title}</span>
        }

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(BreadCrumbs);




